export default {
  bandaid: { alternativeName: 'Plaster', categories: 'Generisk, Behandling, Samvalg' },
  plant: { alternativeName: 'Plante', categories: 'Giftinformasjonen, Livsstil' },
  snake: { alternativeName: 'Slange', categories: 'Giftinformasjonen' },
  gascan: { alternativeName: 'Gassbeholder', categories: 'Giftinformasjonen' },
  medicine: { alternativeName: 'Legemidler', categories: 'Tjeneste, Behandling, Samvalg' },
  spray: { alternativeName: 'Sprayflaske', categories: 'Giftinformasjonen, Livsstil' },
  pizzaslice: { alternativeName: 'Pizza', categories: 'Giftinformasjonen, Livsstil' },
  beerandpills: { alternativeName: 'Rusmidler', categories: 'Giftinformasjonen, Livsstil' },
  dog: { alternativeName: 'Hund', categories: 'Giftinformasjonen, Dyr' },
  mushroom: { alternativeName: 'Sopp', categories: 'Giftinformasjonen, Livsstil' },
  bus: { alternativeName: 'Buss', categories: 'Tjeneste, Kjøretøy' },
  vaccine: { alternativeName: 'Vaksiner', categories: 'Tjeneste, Behandling' },
  referral: { alternativeName: 'Henvisninger', categories: 'Tjeneste' },
  envelope: { alternativeName: 'Konvolutt', categories: 'Tjeneste, Generisk' },
  calendar: { alternativeName: 'Kalender', categories: 'Tjeneste, Generisk' },
  contacts: { alternativeName: 'Helsekontakter', categories: 'Tjeneste' },
  archive: { alternativeName: 'Arkivboks', categories: 'Tjeneste' },
  donorcard: { alternativeName: 'Donorkort', categories: 'Tjeneste' },
  wallet: { alternativeName: 'Lommebok', categories: 'Tjeneste, Generisk' },
  kjernejournal: { alternativeName: 'Kjernejournal', categories: 'Tjeneste' },
  maledoctor: { alternativeName: 'Mannlig lege', categories: 'Tjeneste, Behandling' },
  laboratory: { alternativeName: 'Laboratorieprøver', categories: 'Tjeneste, Behandling' },
  toolbox: { alternativeName: 'Verktøykasse', categories: 'Tjeneste, Generisk' },
  criticalhealthinfo: { alternativeName: 'Sykdom og kritisk informasjon', categories: 'Tjeneste' },
  scale: { alternativeName: 'Vektskål', categories: 'Generisk' },
  poisoninformation: { alternativeName: 'Giftinformasjonen', categories: 'Giftinformasjonen' },
  lightbulb: { alternativeName: 'Lyspære', categories: 'Generisk' },
  europeanhealthcard: { alternativeName: 'Europeisk helsetrygdkort', categories: 'Tjeneste' },
  documents: { alternativeName: 'Dokumenter', categories: 'Tjeneste, Generisk' },
  medicinewarning: { alternativeName: 'Meld bivirkninger', categories: 'Tjeneste' },
  refund: { alternativeName: 'Refusjon', categories: 'Tjeneste' },
  lawbook: { alternativeName: 'Lovbok', categories: 'Generisk' },
  userorganization: { alternativeName: 'Pasient- og brukerorganisasjoner', categories: 'Generisk, Personer' },
  publication: { alternativeName: 'Publikasjon', categories: 'Generisk' },
  facebook: { alternativeName: 'Facebook', categories: 'Sosiale medier' },
  receptionist: { alternativeName: 'Person med headset', categories: 'Generisk, Personer' },
  infosignstroke: { alternativeName: 'Informasjon (lys)', categories: 'Generisk' },
  helpsign: { alternativeName: 'Spørsmål', categories: 'Generisk' },
  globe: { alternativeName: 'Globus', categories: 'Generisk' },
  calendarevent: { alternativeName: 'Kalenderhendelse', categories: 'Generisk' },
  laptopblog: { alternativeName: 'Laptop blogg', categories: 'Generisk, Sosiale medier' },
  snapchat: { alternativeName: 'Snapshat', categories: 'Sosiale medier, Generisk' },
  twitter: { alternativeName: 'Twitter', categories: 'Sosiale medier, Generisk' },
  youtube: { alternativeName: 'Youtube', categories: 'Sosiale medier, Generisk' },
  instagram: { alternativeName: 'Instagram', categories: 'Sosiale medier, Generisk' },
  echat: { alternativeName: 'Sosiale medier (generisk)', categories: 'Sosiale medier, Generisk' },
  journal: { alternativeName: 'Pasientjournal', categories: 'Tjeneste' },
  firstaidkit: { alternativeName: 'Førstehjelpsskrin', categories: 'Giftinformasjonen, Behandling' },
  shakinghand: { alternativeName: 'Hender som holder', categories: 'Tjeneste, Samvalg' },
  hospital: { alternativeName: 'Sykehus', categories: 'Tjeneste, Behandling' },
  microscope: { alternativeName: 'Mikroskop', categories: 'Tjeneste, Behandling' },
  apple: { alternativeName: 'Eple', categories: 'Livsstil' },
  makeup: { alternativeName: 'Sminke', categories: 'Giftinformasjonen' },
  garden: { alternativeName: 'Hage', categories: 'Giftinformasjonen' },
  paintroller: { alternativeName: 'Malingsrull', categories: 'Giftinformasjonen' },
  football: { alternativeName: 'Fotball', categories: 'Giftinformasjonen, Livsstil' },
  pencil: { alternativeName: 'Blyant', categories: 'Giftinformasjonen' },
  hiker: { alternativeName: 'Turgåer', categories: 'Livsstil, Samvalg' },
  personoverweight: { alternativeName: 'Overvektig person', categories: 'Livsstil, Personer' },
  mentalhealthadult: { alternativeName: 'Psykisk helse voksne', categories: 'Psykisk helse' },
  pregnant: { alternativeName: 'Gravid', categories: 'Gravid og fødsel' },
  birthdaycake: { alternativeName: 'Bursdagskake', categories: 'Gravid og fødsel, Generisk' },
  baby: { alternativeName: 'Baby', categories: 'Gravid og fødsel' },
  motherholdingbaby: { alternativeName: 'Kvinne holder baby', categories: 'Gravid og fødsel' },
  cigarette: { alternativeName: 'Sigarett', categories: 'Livsstil' },
  anxiety: { alternativeName: 'Angst', categories: 'Psykisk helse, Sykdom' },
  depression: { alternativeName: 'Depresjon', categories: 'Psykisk helse, Sykdom' },
  teddybear: { alternativeName: 'Teddybjørn', categories: 'Generisk, Sykdom' },
  brain: { alternativeName: 'Hjerne', categories: 'Sykdom, Anatomi' },
  heart: { alternativeName: 'Hjerte', categories: 'Sykdom, Anatomi' },
  skin: { alternativeName: 'Hud og hår', categories: 'Sykdom, Anatomi' },
  cancer: { alternativeName: 'Kreft', categories: 'Sykdom' },
  lungs: { alternativeName: 'Lunger', categories: 'Sykdom, Anatomi' },
  digestivesystem: { alternativeName: 'Fordøyelsessystem', categories: 'Sykdom, Anatomi' },
  skeleton: { alternativeName: 'Skjelett', categories: 'Sykdom, Anatomi' },
  kidney: { alternativeName: 'Nyre', categories: 'Sykdom, Anatomi' },
  dizzy: { alternativeName: 'Svimmel', categories: 'Sykdom' },
  awakepersononpillow: { alternativeName: 'Person som ikke får sove', categories: 'Generisk, Sykdom' },
  tooth: { alternativeName: 'Tann', categories: 'Anatomi' },
  thinkingaboutbaby: { alternativeName: 'Ufrivillig barnløshet', categories: 'Behandling, Sykdom' },
  malegenitalia: { alternativeName: 'Mannlig kjønnsorgan', categories: 'Sykdom, Anatomi' },
  earnosethroat: { alternativeName: 'Øre - nese - hals', categories: 'Sykdom, Anatomi' },
  eye: { alternativeName: 'Øye', categories: 'Sykdom, Anatomi' },
  armflexing: { alternativeName: 'Viser muskler (arm)', categories: 'Livsstil, Anatomi' },
  coronavirus: { alternativeName: 'Koronavirus', categories: 'Sykdom' },
  femaledoctor: { alternativeName: 'Kvinnelig lege', categories: 'Tjeneste, Personer' },
  maledoctorandperson: { alternativeName: 'Mannlig lege og pasient', categories: 'Behandling, Personer' },
  person: { alternativeName: 'Person', categories: 'Generisk, Personer' },
  form: { alternativeName: 'Skjema', categories: 'Tjeneste, Generisk' },
  lock: { alternativeName: 'Hengelås', categories: 'Tjeneste, Generisk' },
  mobilephone: { alternativeName: 'Mobiltelefon', categories: 'Generisk' },
  worksuitcase: { alternativeName: 'Koffert', categories: 'Generisk' },
  window: { alternativeName: 'Vindu', categories: 'Generisk' },
  worddocument: { alternativeName: 'Word fil', categories: 'Filtyper' },
  videochat: { alternativeName: 'Video chat', categories: 'Tjeneste, Generisk' },
  videocamera: { alternativeName: 'Videokamera', categories: 'Generisk' },
  brokenpuzzle: { alternativeName: 'Ødelagt pusslespill', categories: 'Generisk' },
  brokenheart: { alternativeName: 'Knust hjerte', categories: 'Generisk' },
  train: { alternativeName: 'Tog', categories: 'Kjøretøy' },
  ticket: { alternativeName: 'Billett', categories: 'Generisk' },
  taxi: { alternativeName: 'Taxi', categories: 'Kjøretøy' },
  musselsandsalt: { alternativeName: 'Blåskjell og saltbøsse', categories: 'Giftinformasjonen, Livsstil' },
  alarmclock: { alternativeName: 'Vekkeklokke', categories: 'Generisk' },
  arrowleft: { alternativeName: 'Ventrepil', categories: 'System' },
  arrowright: { alternativeName: 'Høyrepil', categories: 'System' },
  calendarsave: { alternativeName: 'Lagre i kalender', categories: 'System' },
  chevrondown: { alternativeName: 'Nedover halvpil', categories: 'System' },
  chevronleft: { alternativeName: 'Venstre halvpil', categories: 'System' },
  chevronright: { alternativeName: 'Høyre halvpil', categories: 'System' },
  chevronup: { alternativeName: 'Oppover halvpil', categories: 'System' },
  cross: { alternativeName: 'Kryss', categories: 'System' },
  enterfullscreen: { alternativeName: 'Fullskjermvisning', categories: 'System' },
  eraser: { alternativeName: 'Viskelær', categories: 'System' },
  exitfullscreen: { alternativeName: 'Gå ut av fullskjermvisning', categories: 'System' },
  nofilter: { alternativeName: 'Fjern filter', categories: 'System' },
  forward: { alternativeName: 'Pil fremover', categories: 'System' },
  menu: { alternativeName: 'Meny', categories: 'System' },
  minus: { alternativeName: 'Minus', categories: 'System' },
  paperplane: { alternativeName: 'Papirfly', categories: 'Generisk' },
  pause: { alternativeName: 'Pause', categories: 'System' },
  pluslarge: { alternativeName: 'Stort pluss', categories: 'System' },
  plussmall: { alternativeName: 'Liten pluss', categories: 'System' },
  printer: { alternativeName: 'Printer', categories: 'Generisk' },
  reply: { alternativeName: 'Svar', categories: 'System' },
  search: { alternativeName: 'Søk', categories: 'Generisk' },
  share: { alternativeName: 'Dele', categories: 'Sosiale medier' },
  save: { alternativeName: 'Lagre', categories: 'System' },
  verticaldots: { alternativeName: 'Vertikale prikker', categories: 'System' },
  upload: { alternativeName: 'Last opp', categories: 'System' },
  bell: { alternativeName: 'Varsel', categories: 'Generisk' },
  check: { alternativeName: 'Avsjekket', categories: 'Generisk' },
  draft: { alternativeName: 'Kladd', categories: 'Generisk' },
  female: { alternativeName: 'Kvinne- tegn', categories: 'Generisk' },
  handwaving: { alternativeName: 'Vinke', categories: 'Generisk' },
  hormone: { alternativeName: 'Hormoner', categories: 'Sykdom, Anatomi' },
  jointpain: { alternativeName: 'Leddsmerte', categories: 'Sykdom, Anatomi' },
  location: { alternativeName: 'Lokasjon', categories: 'Generisk' },
  personinxraymachine: { alternativeName: 'Røntgen', categories: 'Behandling, Sykdom' },
  personwithbrokenarm: { alternativeName: 'Person med brukket arm', categories: 'Behandling, Personer' },
  patientandperson: { alternativeName: 'Pasient og pårørende', categories: 'Behandling, Personer' },
  personwithcrutches: { alternativeName: 'Person med krykker', categories: 'Behandling, Personer' },
  personrelaxing: { alternativeName: 'Person som slapper av', categories: 'Livsstil, Personer' },
  plane: { alternativeName: 'Fly', categories: 'Kjøretøy' },
  puzzle: { alternativeName: 'Puslespillbit', categories: 'Generisk' },
  rocket: { alternativeName: 'Romrakett', categories: 'Kjøretøy' },
  trashcan: { alternativeName: 'Søplekasse', categories: 'Generisk' },
  x: { alternativeName: 'X', categories: 'System' },
  amputation: { alternativeName: 'Amputasjon', categories: 'Behandling, Personer' },
  childplaying: { alternativeName: 'Barn leker', categories: 'Livsstil, Personer' },
  breasts: { alternativeName: 'Pupper', categories: 'Anatomi, Sykdom, Samvalg' },
  arrowupright: { alternativeName: 'Pil oppover mot høyre', categories: 'System' },
  attachment: { alternativeName: 'Vedlegg', categories: 'Generisk' },
  atv: { alternativeName: 'ATV', categories: 'Kjøretøy' },
  bike: { alternativeName: 'Sykkel', categories: 'Kjøretøy, Livsstil' },
  boat: { alternativeName: 'Båt', categories: 'Kjøretøy' },
  mentalhealthchild: { alternativeName: 'Mental helse barn', categories: 'Psykisk helse, Sykdom' },
  copy: { alternativeName: 'Kopi', categories: 'System' },
  cough: { alternativeName: 'Hoste', categories: 'Sykdom, Behandling' },
  elderlyperson: { alternativeName: 'Eldre', categories: 'Livsstil, Personer' },
  epilepsy: { alternativeName: 'Epilepsi', categories: 'Sykdom' },
  ferry: { alternativeName: 'Ferje', categories: 'Kjøretøy' },
  handwithdisease: { alternativeName: 'Hånd med utslett', categories: 'Sykdom, Anatomi' },
  errorsignfill: { alternativeName: 'Feilmelding (mørk)', categories: 'Generisk' },
  errorsignstroke: { alternativeName: 'Feilmelding (lys)', categories: 'Generisk' },
  fingerbleed: { alternativeName: 'Finger som blør', categories: 'Sykdom, Behandling' },
  history: { alternativeName: 'Historikk', categories: 'Generisk' },
  hivandaids: { alternativeName: 'HIV og Aids', categories: 'Sykdom' },
  imgfile: { alternativeName: 'Bildefil', categories: 'Filtyper' },
  inbox: { alternativeName: 'Innboks', categories: 'Generisk' },
  jpgfile: { alternativeName: 'Jpg-fil', categories: 'Filtyper' },
  mirror: { alternativeName: 'Speil', categories: 'Generisk' },
  muscleback: { alternativeName: 'Ryggmuskler', categories: 'Anatomi' },
  muscleleg: { alternativeName: 'Leggmuskler', categories: 'Anatomi' },
  notepad: { alternativeName: 'Skriveblokk', categories: 'Generisk' },
  pdffile: { alternativeName: 'PDF', categories: 'Filtyper' },
  personwithbrain: { alternativeName: 'Person med hjerne', categories: 'Anatomi, Personer' },
  personwithjaw: { alternativeName: 'Person med kjeve', categories: 'Anatomi, Personer' },
  personwithmagnifyingglass: { alternativeName: 'Person med lupe', categories: 'Behandling, Personer' },
  personwithsenses: { alternativeName: 'Person med sanser', categories: 'Psykisk helse, Personer' },
  personworking: { alternativeName: 'Person som jobber', categories: 'Generisk, Personer, Samvalg' },
  pngfile: { alternativeName: 'PNG', categories: 'Filtyper' },
  psychosis: { alternativeName: 'Psykose', categories: 'Sykdom, Psykisk helse' },
  refresh: { alternativeName: 'Oppdater', categories: 'Generisk' },
  rtffile: { alternativeName: 'RTF-fil', categories: 'Filtyper' },
  xmlfile: { alternativeName: 'XML', categories: 'Filtyper' },
  receipt: { alternativeName: 'Kvittering', categories: 'Generisk' },
  infosignfill: { alternativeName: 'Informasjon (mørk)', categories: 'Generisk' },
  chest: { alternativeName: 'Kiste', categories: 'Generisk' },
  breastreconstruction: { alternativeName: 'Brystrekonstruksjon', categories: 'Samvalg' },
  breastremoval: { alternativeName: 'Brystfjerning', categories: 'Samvalg' },
  activemonitoring: { alternativeName: 'Aktiv overvåkning', categories: 'Samvalg' },
  surgery: { alternativeName: 'Kirurgi', categories: 'Samvalg, Behandling' },
  intravenous: { alternativeName: 'Intravenøs', categories: 'Samvalg, Behandling' },
  radioiodine: { alternativeName: 'Radiojod', categories: 'Samvalg' },
  hipprosthesis: { alternativeName: 'Hofteprotese', categories: 'Samvalg' },
  shuntoperation: { alternativeName: 'Shunt-operasjon', categories: 'Samvalg' },
  timepassing: { alternativeName: 'Tiden går', categories: 'Samvalg' },
  osteotomy: { alternativeName: 'Osteotomi', categories: 'Samvalg' },
  uniprosthesis: { alternativeName: 'Uniprotese', categories: 'Samvalg' },
  fullkneeprosthesis: { alternativeName: 'Total kneprotese', categories: 'Samvalg' },
  transplantation: { alternativeName: 'Transplantasjon', categories: 'Samvalg' },
  peritonealdialysis: { alternativeName: 'Peritoneal dialyse', categories: 'Samvalg' },
  hemodialysis: { alternativeName: 'Hemodialyse', categories: 'Samvalg' },
  embolization: { alternativeName: 'Cyster', categories: 'Samvalg, Sykdom' },
  radioactivetreatment: { alternativeName: 'Radioaktiv behandling', categories: 'Samvalg' },
  radiotherapy: { alternativeName: 'Strålebehandling', categories: 'Samvalg' },
  peopletalking: { alternativeName: 'Samtale', categories: 'Samvalg, Personer' },
  music: { alternativeName: 'Musikk', categories: 'Samvalg' },
  helpinghand: { alternativeName: 'Hjelpende hånd', categories: 'Samvalg' },
  kitchenscale: { alternativeName: 'Kjøkkenvekt', categories: 'Samvalg' },
  wheelchair: { alternativeName: 'Rullestol', categories: 'Generisk, Behandling' },
  wheelchairactive: { alternativeName: 'Rullestol aktov', categories: 'Generisk, Personer' },
  healthclinic: { alternativeName: 'Helsesenter', categories: 'Generisk, Behandling' },
  teenagers: { alternativeName: 'Tenåringer', categories: 'Generisk, Personer' },
  website: { alternativeName: 'Nettside', categories: 'Generisk' },
  settings: { alternativeName: 'Innstillinger', categories: 'System' },
  undo: { alternativeName: 'Angre', categories: 'System' },
  coronacertificate: { alternativeName: 'Koronasertifikat', categories: 'Tjeneste' },
  watch: { alternativeName: 'Klokke', categories: 'Generisk' },
  totalkneeprosthesis: { alternativeName: 'Full kneprotese', categories: 'Samvalg, Behandling' },
  stopwatch: { alternativeName: 'Stoppeklokke', categories: 'Generisk' },
  podcast: { alternativeName: 'Podcast', categories: 'Generisk' },
  play: { alternativeName: 'Play', categories: 'Generisk' },
  hourglass: { alternativeName: 'Timeglass', categories: 'Generisk' },
  floppydisk: { alternativeName: 'Diskett', categories: 'Generisk' },
  download: { alternativeName: 'Last ned', categories: 'System, Generisk' },
  dataexchange: { alternativeName: 'Datautveklsling', categories: 'System, Generisk' },
  datareceived: { alternativeName: 'Data motatt', categories: 'System, Generisk' },
  datasent: { alternativeName: 'Data sendt', categories: 'System, Generisk' },
  chevronsdown: { alternativeName: 'Dobbelpil ned', categories: 'System, Generisk' },
  chevronsup: { alternativeName: 'Dobbeltpil opp', categories: 'System, Generisk' },
  change: { alternativeName: 'Endre', categories: 'System, Generisk' },
  calendarchange: { alternativeName: 'Kalender endring', categories: 'System, Generisk' },
  calendarcheck: { alternativeName: 'Kalender ok', categories: 'System, Generisk' },
  healthwarning: { alternativeName: 'Helseadvarsel', categories: 'Tjeneste' },
  zoom: { alternativeName: 'Zoom inn', categories: 'System, Generisk' },
  checkoutline: { alternativeName: 'Avhukning', categories: 'System, Generisk' },
  shield: { alternativeName: 'Skjold', categories: 'System, Generisk' },
  xoutline: { alternativeName: 'X', categories: 'System, Generisk' },
  recovery: { alternativeName: 'Gjenoppretting', categories: 'System, Generisk' },
  body: { alternativeName: 'Kropp', categories: 'Anatomi, Personer' },
  genderidentity: { alternativeName: 'Kjønnsidentitet', categories: 'Generisk, Personer' },
  home: { alternativeName: 'Hjem', categories: 'Generisk' },
  qrcode: { alternativeName: 'QR kode', categories: 'Generisk' },
  quarrel: { alternativeName: 'Krangle', categories: 'Generisk' },
  sexualorientation: { alternativeName: 'Seksuell orientering', categories: 'Generisk' },
  birthcontrol: { alternativeName: 'Prevensjon', categories: 'Generisk' },
  gallery: { alternativeName: 'Galleri', categories: 'System' },
  list: { alternativeName: 'Liste', categories: 'System' },
  stds: { alternativeName: 'Kjønnssykom', categories: 'Sykdom, Personer' },
  acupunctureback: { alternativeName: 'Akupunktur rygg', categories: 'Samvalg, Generisk' },
  noeye: { alternativeName: 'Øye m strek', categories: 'System' },
  sectionsign: { alternativeName: 'Paragraftegn', categories: 'Samvalg, Generisk' },
  speechbubble: { alternativeName: 'Snakkeboble', categories: 'Samvalg, Generisk' },
  supportingperson: { alternativeName: 'Ledsager', categories: 'Samvalg, Personer' },
  syringe: { alternativeName: 'Sprøyte', categories: 'Samvalg, Generisk' },
  car: { alternativeName: 'Bil', categories: 'Kjøretøy' },
  group: { alternativeName: 'Gruppe', categories: 'Personer' },
  checkfill: { alternativeName: 'Utfylt sjekkboks', categories: 'System' },
  personalplan: { alternativeName: 'Behandlingsplan', categories: 'Tjeneste' },
  emoticonannoyed: { alternativeName: 'Emoji Irritert', categories: 'Generisk' },
  emoticondelighted: { alternativeName: 'Emoji Lykkelig', categories: 'Generisk' },
  emoticondisappointed: { alternativeName: 'Emoji Skuffet', categories: 'Generisk' },
  emoticonhappy: { alternativeName: 'Emoji Glad', categories: 'Generisk' },
  emoticonmeh: { alternativeName: 'Emoji Nøytral', categories: 'Generisk' },
  sortdown: { alternativeName: 'Sortere ned', categories: 'System, Generisk' },
  sortup: { alternativeName: 'Sortere opp', categories: 'System, Generisk' },
  filter: { alternativeName: 'Filter', categories: 'System, Generisk' },
  personcancel: { alternativeName: 'Person Avbryt', categories: 'Generisk, Tjeneste' },
  travelroute: { alternativeName: 'Reiserute', categories: 'Generisk, Tjeneste' },
  coins: { alternativeName: 'Mynter', categories: 'Generisk, Tjeneste' },
  hearthands: { alternativeName: 'Hjertehender', categories: 'System, Generisk' },
  trianglex: { alternativeName: 'TriangelX', categories: 'System, Generisk' },
  login: { alternativeName: 'Logg inn', categories: 'System, Generisk' },
  logout: { alternativeName: 'Logg ut', categories: 'System, Generisk' },
  'sort-a-z': { alternativeName: 'Sortere', categories: 'System, Generisk' },
  file: { alternativeName: 'Fil', categories: 'System, Generisk' },
  handsandheart: { alternativeName: 'Hender og Hjerte', categories: 'Generisk' },
  tombstone: { alternativeName: 'Gravstein', categories: 'Generisk' },
  candle: { alternativeName: 'Kubbelys', categories: 'Generisk' },
  legaldocument: { alternativeName: 'Juridisk Dokument', categories: 'Generisk' },
  fallingleaf: { alternativeName: 'Fallende Blad', categories: 'Generisk' },
  graph: { alternativeName: 'Graf', categories: 'System, Generisk' },
  healthcarepersonnel: { alternativeName: 'Helsepersonell', categories: 'Generisk, Personer' },
  healthcareperson: { alternativeName: 'Helseperson', categories: 'Generisk, Personer' },
  grouptwins: { alternativeName: 'Gruppe Tvillinger', categories: 'Generisk, Personer' },
  sun: { alternativeName: 'Sol', categories: 'Generisk' },
  ear: { alternativeName: 'Øre', categories: 'Generisk, Syn og hørsel' },
  earhearingaid: { alternativeName: 'Øre Høreapparat', categories: 'Generisk, Syn og hørsel' },
  earvolume: { alternativeName: 'Øre Volum', categories: 'Generisk, Syn og hørsel' },
  eardeaf: { alternativeName: 'Øre Døv', categories: 'Generisk, Syn og hørsel' },
  braille: { alternativeName: 'Blindeskrift', categories: 'Generisk, Syn og hørsel' },
  screenreader: { alternativeName: 'Skjermleser', categories: 'Generisk, Syn og hørsel' },
  hearingprotection: { alternativeName: 'Hørselsvern', categories: 'Generisk, Syn og hørsel' },
  htmlfile: { alternativeName: 'HTML-fil', categories: 'Filtyper' },
  emergencycall: { alternativeName: 'Nødsamtale', categories: 'Generisk' },
  glasses: { alternativeName: 'Briller', categories: 'Generisk, Syn og hørsel' },
  carton: { alternativeName: 'Kartong', categories: 'Generisk' },
  creditcard: { alternativeName: 'Kredittkort', categories: 'Generisk' },
  fish: { alternativeName: 'Fisk', categories: 'Generisk' },
  glasswater: { alternativeName: 'Vannglass', categories: 'Generisk' },
  grain: { alternativeName: 'Korn', categories: 'Generisk' },
  plateknifefork: { alternativeName: 'TallerkenKnivGaffel', categories: 'Generisk' },
  reminder: { alternativeName: 'Påminnelse', categories: 'Generisk' },
  sweets: { alternativeName: 'Søtsaker', categories: 'Generisk' },
  maledoctorcompact: { alternativeName: '', categories: 'System, Mobil' },
  maledoctorcompactfill: { alternativeName: '', categories: 'System, Mobil' },
  settingsfill: { alternativeName: '', categories: 'System, Mobil' },
  homefill: { alternativeName: '', categories: 'System, Mobil' },
  locationfill: { alternativeName: '', categories: 'System, Mobil' },
  emptybox: { alternativeName: 'TomEske', categories: 'Generisk' },
  stickynote: { alternativeName: 'Huskelapp', categories: 'Generisk' },
  stickynotes: { alternativeName: 'Huskelapper', categories: 'Generisk' },
  sharedhealthdata: { alternativeName: 'DelteHelseData', categories: 'Tjeneste, Generisk' },
  sharedhealthmeasurements: { alternativeName: 'DelteHelseMålinger', categories: 'Generisk, Tjeneste' },
  healthmeasurements: { alternativeName: 'HelseMålinger', categories: 'Generisk, Tjeneste' },
  dotexclamationmark: { alternativeName: '', categories: 'System, StatusDot' },
  dotx: { alternativeName: '', categories: 'System, StatusDot' },
  dotinfo: { alternativeName: '', categories: 'System, StatusDot' },
  dotcheckmark: { alternativeName: '', categories: 'System, StatusDot' },
  dotoutline: { alternativeName: '', categories: 'System, StatusDot' },
  dothalfdisc: { alternativeName: '', categories: 'System, StatusDot' },
  dotlookingglass: { alternativeName: '', categories: 'System, StatusDot' },
  dotquestionmark: { alternativeName: '', categories: 'System, StatusDot' },
  dottriangle: { alternativeName: '', categories: 'System, StatusDot' },
  dotfill: { alternativeName: '', categories: 'System, StatusDot' },
  dotdot: { alternativeName: '', categories: 'System, StatusDot' },
  dotgroup: { alternativeName: '', categories: 'System, StatusDot' },
  dotcirclearrows: { alternativeName: '', categories: 'System, StatusDot' },
  dotnoaccess: { alternativeName: '', categories: 'System, StatusDot' },
  dotpencil: { alternativeName: '', categories: 'System, StatusDot' },
  dotnoeye: { alternativeName: '', categories: 'System, StatusDot' },
  dotlogin: { alternativeName: '', categories: 'System, StatusDot' },
  dotattachment: { alternativeName: '', categories: 'System, StatusDot' },
  alertsignfill: { alternativeName: 'Advarselskilt (mørk)', categories: 'System' },
  alertsignstroke: { alternativeName: 'Advarselskilt', categories: 'System' },
  avatar: { alternativeName: 'Avatar', categories: 'Generisk, Personer' },
  noaccess: { alternativeName: 'IngenTilgang (mørk)', categories: 'System' },
  personandpatient: { alternativeName: 'PårørendeOgPasient', categories: 'Behandling, Personer' },
  toddler: { alternativeName: 'Småbarn', categories: 'Tjeneste' },
  treatmentaids: { alternativeName: 'Behandlingshjelpemidler', categories: 'Tjeneste' },
  drag: { alternativeName: 'Dra', categories: 'System' },
  edit: { alternativeName: 'Rediger', categories: 'System' },
  feedback: { alternativeName: 'Tilbakemelding', categories: 'Generisk' },
  zoominleft: { alternativeName: 'Zoom Inn Venstre', categories: 'System, Generisk' },
  zoomoutleft: { alternativeName: 'Zoom Ut Venstre', categories: 'System, Generisk' },
  sort: { alternativeName: '', categories: 'System, Generisk' },
  starstroke: { alternativeName: '', categories: '' },
  starfill: { alternativeName: '', categories: '' },
  measuringtape: { alternativeName: '', categories: '' },
};
